import type { ReadonlyVec2, Seconds } from "@core/types";
import type { Player } from "@entities/player";
import { PLAYER_BOUNDS, PLAYER_SPEED_GLOW, PLAYER_SPEED_NORMAL } from "@data/balance";

const clamp = (v: number, min: number, max: number): number => Math.min(max, Math.max(min, v));

/**
 * Чистая функция: применяет вектор движения к player.position,
 * обновляет facing и isMoving.
 */
export const applyMovement = (
  player: Player,
  axis: ReadonlyVec2,
  glow: boolean,
  dt: Seconds,
): void => {
  const speed = glow ? PLAYER_SPEED_GLOW : PLAYER_SPEED_NORMAL;
  player.position = {
    x: clamp(player.position.x + axis.x * speed * dt, PLAYER_BOUNDS.x[0], PLAYER_BOUNDS.x[1]),
    y: clamp(player.position.y + axis.y * speed * dt, PLAYER_BOUNDS.y[0], PLAYER_BOUNDS.y[1]),
  };
  player.isMoving = Math.abs(axis.x) + Math.abs(axis.y) > 0.05;
  if (axis.x < -0.05) player.facing = "left";
  else if (axis.x > 0.05) player.facing = "right";
};
